import { render, staticRenderFns } from "./ModalResponsible.vue?vue&type=template&id=8b6b0f36&scoped=true"
import script from "./ModalResponsible.vue?vue&type=script&lang=js"
export * from "./ModalResponsible.vue?vue&type=script&lang=js"
import style0 from "./ModalResponsible.vue?vue&type=style&index=0&id=8b6b0f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b0f36",
  null
  
)

export default component.exports